// src/hoc/withAbility.js
import React from 'react';
import { connect } from 'react-redux';
import { defineAbilitiesFor } from '../helpers/ability.helper';

const withAbility = (WrappedComponent) => {
  class WithAbilityWrapper extends React.Component {
    constructor(props) {
      super(props);
      const ability = defineAbilitiesFor(props.user);
      this.state = { ability };
    }

    componentDidUpdate(prevProps) {
      if (prevProps.user !== this.props.user) {
        const ability = defineAbilitiesFor(this.props.user);
        this.setState({ ability });
      }
    }

    render() {
      const { ability } = this.state;
      return <WrappedComponent {...this.props} ability={ability} />;
    }
  }

  const mapStateToProps = (state) => ({
    user: state.authentication.user,
  });

  return connect(mapStateToProps)(WithAbilityWrapper);
};

export default withAbility;
